// extracted by mini-css-extract-plugin
module.exports = {"balanceMessage":"az_fxc","redeemedReward":"az_gxc","gainedReward":"az_hxc"};